export default "/_next/static/images/effect-right-1-3d6ebc9cb26b2dd01c70ba0968f967c6.svg";